module.exports = __webpack_public_path__ + "img/visa.40032071.jpg";